import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import feedback from '../../../assets/img/notify.jpg';
import moment from 'moment';
import { browsetaskSeller, getMyTaskListSeller, opentaskSeller } from '../../../Redux/Task/action';
import { IMAGE_URL } from '../../../api';
import Pagination from '../../Pagination';
import InfiniteScroll from 'react-infinite-scroll-component';
import ToasterMessage from '../../ToasterMessage';
// import Pagination from "react-custom-pagination";


const MyTaskSeller = () => {

    const { state } = useLocation();
    const [toaster, setToaster] = useState("");
    const navigate = useNavigate();
    const [tasks, setTasks] = useState([])
    const [data, setData] = useState([]);
    const [update, setUpdate] = useState(false);
    const notification_data = localStorage.getItem('notification_data');
    const [pageStatus, setPageStatus] = useState(2);
    const [totalPageNumber, setTotalPageNumber] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);



    const sellerTask = (page = currentPage, status = pageStatus) => {
        setPageStatus(status)
        let formData = new FormData();
        formData.append('status_object', status);
        formData.append('page', page);
        formData.append('per_page', 9);
        // formData.append('limit', 9);
        // formData.append('sort_order', 1);
        // formData.append('category', 1);

        getMyTaskListSeller({ formData })((response) => {

            if (response && response.status) {

                console.log(response?.data?.data,"task response");

                setTasks(response?.data?.data)
                setUpdate(true)
                setTotalPageNumber(response?.data?.total_pages)
                if (response?.data?.data.length < response?.data?.count)
                    setHasMore(true);
                else
                    setHasMore(false);

                setPage(2)

            }
        });
    }
    const sellerTaskOpen = (page = currentPage) => {

        let formData = new FormData();
        formData.append('page', page);
        formData.append('per_page', 9);

        browsetaskSeller(currentPage, 9)((response) => {
            if (response?.status && response?.data) {

                setData(response?.data?.data)
                setTotalPageNumber(response?.data?.total_pages)
            }
        });
    }

    useEffect(() => {
        sellerTaskOpen();
        sellerTask();
    }, []);

    useEffect(() => {
        if (state?.toaster) {
            setToaster("Task Successfully Completed")
            setTimeout(() => {
                setToaster("")
                window.history.replaceState({}, document.title)
            }, 2000);

        }
    }, [state])


    // const getStatusdata = (status, page = currentPage,) => {
    //     let formData = new FormData();
    //     formData.append('status_object', status);
    //     formData.append('page', page);
    //     formData.append('per_page', 9);
    //     formData.append('limit', 9);
    //     getMyTaskListSeller({ formData })((response) => {
    //         if (response && response.status) {
    //             setTasks(response?.data?.data)
    //             setUpdate(!update)
    //         }
    //     });
    // }
    const swicthButton = (e) => {

    }
    const updatePage = () => {

        sellerTask();
    }
    // const paginate = (number) => {
    //     setCurrentPage(number);
    // };
    const [page, setPage] = useState(1)
    const [openpage, setOpenpage] = useState(1)
    const [hasMore, setHasMore] = useState(true)

    const paginate = () => {
        let formData = new FormData();
        formData.append('status_object', pageStatus);
        formData.append('page', page);
        formData.append('per_page', 9);
        getMyTaskListSeller({ formData })((response) => {
            if (response.status) {
                if ((tasks.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setTasks(tasks.concat(response?.data?.data))
            }
            else {
                setHasMore(false)
            }
        })
        setPage(page + 1)
    }
    const paginateOpen = () => {
        browsetaskSeller(page, 9)((response) => {
            if (response.status) {

                if ((data.length + response?.data?.data.length) >= response?.data?.count) {

                    setHasMore(false)
                }
                setData(data.concat(response?.data?.data))
            }
            else {
                setHasMore(false)
            }
        })
        setOpenpage(openpage + 1)
    }
    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header updatePage={updatePage} />

            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> My Task</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <button className='btn btn-primary ' id="notification-btn-click1" onClick={() => { setUpdate(!update); alert('button') }} >asdasd</button> */}
            {/* <section className='my-tasks'>
                <div className='container'>
                    <div className='row'>
                        <Tab.Container id="" defaultActiveKey="first">
                            <Row>
                                <Col sm={12}>
                                    <Nav variant="pills" className="">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first" onClick={() => getStatusdata(2)}>Opened</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second" onClick={() => getStatusdata(3)}>Completed</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        <div className=''>
                                            <h5 className='posted-tasks'>Posted Tasks</h5>
                                        </div>
                                    </div>
                                </div>
                                <Col sm={12}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first" onClick={(e) => swicthButton(e)}>
                                            <section className="mytask-buyer section-bg p-0">
                                                <div className="container">
                                                    <div className="row">
                                                        {tasks?.map((task, index) =>
                                                            <React.Fragment>
                                                                {task?.status == 2 &&
                                                                    <div className="col-lg-4">
                                                                        <div className="member d-flex align-items-start">
                                                                            <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                                                                            <div className="member-info">
                                                                                <h4>{task?.task_details?.title}</h4>
                                                                                <p><i className="bi bi-calendar"></i> {moment(task?.task_details?.date_choice).format('ll')}</p>
                                                                                <p><i className="bi bi-clock"></i> 10 AM - 2 PM</p>
                                                                                <span className="badge badge-light-warning">{task?.status == 2 ? "Ongoing" : "Completed"}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                        )}
                                                    </div>

                                                </div>
                                            </section>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <section className="mytask-buyer section-bg p-0">
                                                <div className="container">
                                                    <div className="row">
                                                        {tasks?.map((task, index) =>
                                                            <React.Fragment>
                                                                {task?.status == 3 &&
                                                                    <div className="col-lg-4">
                                                                        <div className="member d-flex align-items-start">
                                                                            <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                                                                            <div className="member-info">
                                                                                <h4>{task?.task_details?.title}</h4>
                                                                                <p><i className="bi bi-calendar"></i> {moment(task?.task_details?.date_choice).format('ll')}</p>
                                                                                <p><i className="bi bi-clock"></i> 10 AM - 2 PM</p>
                                                                                <span className="badge badge-light-success">{task?.status == 3 ? "Ongoing" : "Completed"}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                        )}

                                                    </div>
                                                </div>
                                            </section>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </section> */}
            <section id="features" className="features">

                <div className="container">

                    <ul className="nav nav-tabs row gy-4 d-flex">

                        <li onClick={() => { sellerTaskOpen() }} className="nav-item col-6 col-md-4 col-lg-4">
                            <a className="nav-link active show" data-bs-toggle="tab" data-bs-target="#tab-1">
                                <i className="bi bi-envelope-paper"></i>
                                <h4>Open</h4>
                            </a>
                        </li>

                        <li onClick={() => { sellerTask(1, 2) }} className="nav-item col-6 col-md-4 col-lg-4">
                            <a className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-2">
                                <i className="bi bi-envelope-paper"></i>
                                <h4>Assigned</h4>
                            </a>
                        </li>

                        <li onClick={() => { sellerTask(1, 3) }} className="nav-item col-6 col-md-4 col-lg-4">
                            <a className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-3">
                                <i className="bi bi-file-earmark-check-fill"></i>
                                <h4>Completed</h4>
                            </a>
                        </li>

                    </ul>

                    <div className="tab-content">

                        <div className="tab-pane active show" id="tab-1" onClick={(e) => swicthButton(e)}>
                            <section className="mytask-buyer section-bg p-0">
                                <InfiniteScroll
                                    dataLength={data.length}
                                    next={paginateOpen}
                                    hasMore={hasMore}
                                    loader={<p style={{ textAlign: 'center' }}>
                                        <b>Loading...</b>
                                    </p>}
                                    endMessage={
                                        <p style={{ textAlign: 'center' }}>
                                            <b>Yay! You have seen it all</b>
                                        </p>
                                    }
                                >
                                    <div className="container">
                                        <div className="row">
                                            {data?.map((datas, index) =>
                                                <React.Fragment>
                                                    <div className="col-lg-4">
                                                        <div className='mytask-buyer-link' onClick={() => navigate('/makeanoffer', { state: { data: datas } })}>
                                                            <div className="member d-flex align-items-start">
                                                                <div className="pic"><img src={IMAGE_URL + datas?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                                <div className="member-info">
                                                                    <div className='d-flex justify-content-center'>
                                                                        <h4>{datas?.title}</h4>
                                                                    </div>
                                                                    {datas?.location == "" || datas.location == null ?
                                                                        <></>
                                                                        :
                                                                        <p><i className="bi bi-geo-alt-fill me-2"></i>{datas?.location}</p>
                                                                    }
                                                                    <p><i className="bi bi-calendar me-2"></i> {moment(datas?.date_choice).format('ll')}</p>
                                                                    <p><i className="bi bi-clock me-2"></i> {datas?.time_slot == 1 ? "Before 10 AM" : datas?.time_slot == 2 ? "10 AM - 2 PM" : datas?.time_slot == 3 ? "2 PM - 6 PM" : datas?.time_slot == 4 && "After 6 PM"}</p>

                                                                    <div className='badge-w-set'>
                                                                        <span className="badge badge-light-success me-2">{datas?.status[0]?.status == 1 ? "Open" : datas?.status[0]?.status == 2 ? "Assigned" : datas?.status[0]?.status == 3 && "Completed"}</span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>

                                    </div>
                                </InfiniteScroll>
                            </section>
                        </div>

                        <div className="tab-pane" id="tab-2">
                            <section className="mytask-buyer section-bg p-0">
                                <InfiniteScroll
                                    dataLength={tasks.length}
                                    next={paginate}
                                    hasMore={hasMore}
                                    loader={<p style={{ textAlign: 'center' }}>
                                        <b>Loading...</b>
                                    </p>}
                                    endMessage={
                                        <p style={{ textAlign: 'center' }}>
                                            <b>Yay! You have seen it all</b>
                                        </p>
                                    }
                                >
                                    <div className="container">
                                        <div className="row">
                                            {tasks?.map((task, index) =>
                                                <React.Fragment>
                                                    {task?.status == 2 &&
                                                        <div className="col-lg-4">
                                                            <div className='mytask-buyer-link' onClick={() => navigate('/mytasklistingseller', { state: { data: task } })}>
                                                                <div className="member d-flex align-items-start">
                                                                    <div className="pic"><img src={IMAGE_URL + task?.task_details?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                                    <div className="member-info">
                                                                        <div className='task_title_main'>
                                                                            <h4>{task?.task_details?.title}</h4>
                                                                        </div>
                                                                        {task?.task_details?.location == "" ?
                                                                            <></>
                                                                            :
                                                                            <p><i className="bi bi-geo-alt-fill me-2"></i>{task?.task_details?.location}</p>
                                                                        }
                                                                        <p><i className="bi bi-calendar me-2"></i> {moment(task?.task_details?.date_choice).format('ll')}</p>
                                                                        <p><i className="bi bi-clock me-2"></i> {task?.task_details?.time_slot == 1 ? "Before 10 AM" : task?.task_details?.time_slot == 2 ? "10 AM - 2 PM" : task?.task_details?.time_slot == 3 ? "2 PM - 6 PM" : task?.task_details?.time_slot == 4 && "After 6 PM"}</p>
                                                                        <div className='badge-w-set'>
                                                                            <span className="badge badge-light-warning me-2">{task?.status == 2 ? "In Progress" : "Completed"}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </React.Fragment>
                                            )}
                                        </div>

                                    </div>
                                </InfiniteScroll>
                            </section>
                        </div>

                        <div className="tab-pane" id="tab-3">
                            <section className="mytask-buyer section-bg p-0">
                                <InfiniteScroll
                                    dataLength={tasks.length}
                                    next={paginate}
                                    hasMore={hasMore}
                                    loader={<p style={{ textAlign: 'center' }}>
                                        <b>Loading...</b>
                                    </p>}
                                    endMessage={
                                        <p style={{ textAlign: 'center' }}>
                                            <b>Yay! You have seen it all</b>
                                        </p>
                                    }
                                >
                                    <div className="container">
                                        <div className="row">
                                            {tasks?.map((task, index) =>
                                                <React.Fragment>
                                                    {task?.status == 3 &&
                                                        <div className="col-lg-4">
                                                            <div className='mytask-buyer-link' onClick={() => navigate('/mytaskcompletedseller', { state: { data: task } })}>
                                                                <div className="member d-flex align-items-start">
                                                                    <div className="pic"><img src={IMAGE_URL + task?.task_details?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                                    <div className="member-info">
                                                                        <div className='task_title_main'>
                                                                            <h4>{task?.task_details?.title}</h4>
                                                                        </div>
                                                                        {task?.task_details?.location == "" ?
                                                                            <></>
                                                                            :
                                                                            <p><i className="bi bi-geo-alt-fill me-2"></i>{task?.task_details?.location}</p>
                                                                        }
                                                                        <p><i className="bi bi-calendar me-2"></i> {moment(task?.task_details?.date_choice).format('ll')}</p>
                                                                        <p><i className="bi bi-clock me-2"></i> {task?.task_details?.time_slot == 1 ? "Before 10 AM" : task?.task_details?.time_slot == 2 ? "10 AM - 2 PM" : task?.task_details?.time_slot == 3 ? "2 PM - 6 PM" : task?.task_details?.time_slot == 4 && "After 6 PM"}</p>
                                                                        <div className='badge-w-set'>
                                                                            <span className="badge badge-light-success me-2">{task?.status == 3 ? "Completed" : "Ongoing"}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </React.Fragment>
                                            )}

                                        </div>
                                    </div>
                                </InfiniteScroll>
                            </section>
                        </div>

                    </div>

                </div>
            </section>
            {/* <Pagination setCurrentPage={setCurrentPage} total_pages={totalPageNumber} /> */}
            {/* <div className='pagination_pages'>
                <Pagination
                    totalPosts={50}
                    postsPerPage={5}
                    paginate={paginate}
                    view={5}
                    showLast={true}
                    showFirst={true}
                    showIndex={true}
                    style={{ gap: "20px" }}
                />
            </div> */}
            <Footer />
        </React.Fragment>
    )
}

export default MyTaskSeller;